"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _container = _interopRequireDefault(require("../container"));

var _panelText = _interopRequireDefault(require("../../components/panel-text"));

var _background = _interopRequireDefault(require("../../components/background"));

var _utils = require("../../utils");

var _excluded = ["children", "title", "titleFont", "subtitle", "subtitleFont", "description", "descriptionFont"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Background color, a string which represents a color from the color library */
  backgroundColor: _propTypes.string,

  /** Background Image source, a url/path to a background image */
  backgroundImage: _propTypes.string,

  /** Content components, usually a set of 2 to 5 Flexible Items */
  children: _propTypes.node,

  /** Description, usually a text string */
  description: _propTypes.node,
  descriptionColor: _propTypes.string,
  descriptionFont: _utils.fontPropType,
  subtitle: _propTypes.node,
  subtitleFont: _utils.fontPropType,

  /** Title, usually a text string */
  title: _propTypes.node,
  titleColor: _propTypes.string,
  titleFont: _utils.fontPropType
};
/**
 * FlexibleBlock is a component that includes a Text Panel, possibly followed
 * by a number of components, usually 2 to 5 Flexible Items
 */

var FlexibleBlock = function FlexibleBlock(_ref) {
  var children = _ref.children,
      title = _ref.title,
      titleFont = _ref.titleFont,
      subtitle = _ref.subtitle,
      subtitleFont = _ref.subtitleFont,
      description = _ref.description,
      descriptionFont = _ref.descriptionFont,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_background["default"], _extends({
    alignItems: "center",
    flexDirection: "column",
    p: 4
  }, props), (title || subtitle || description) && /*#__PURE__*/_react["default"].createElement(_container["default"], {
    alignItems: "center",
    flexDirection: "column",
    mb: [4, 5],
    px: [0, 1, 2],
    tag: "header",
    width: [1, 2 / 3]
  }, /*#__PURE__*/_react["default"].createElement(_panelText["default"], {
    description: description,
    descriptionFont: descriptionFont,
    subtitle: subtitle,
    subtitleFont: subtitleFont,
    textAlign: "center",
    title: title,
    titleFont: titleFont
  })), children && /*#__PURE__*/_react["default"].createElement(_container["default"], {
    flexDirection: "row",
    flexWrap: "wrap",
    px: [0, 1],
    py: [0, 1]
  }, children));
};

FlexibleBlock.propTypes = propTypes;
var _default = FlexibleBlock;
exports["default"] = _default;